export default __webpack_public_path__ + "static/media/expenseIcon.69cca992.svg";